var render = function render(){var _vm=this,_c=_vm._self._c;return _c('progress',{style:({'--value':_vm.value , '--max': 100, '--progress-value-color':_vm.rawColor, '--progress-bg-color':_vm.rawbg}),attrs:{"max":100},domProps:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }